import online from './online';

const actions = {
	online,
};

export default actions;
